import { computed, ref } from "vue";
import { defineStore } from "pinia";

export const useThemeStore = defineStore("theme", () => {
  // index.html restores this before the first paint, including on a direct route visit.
  const modes = ["light", "mist", "dark"];
  const restored = document.documentElement.dataset.theme;
  const mode = ref(modes.includes(restored) ? restored : "mist");
  const isDark = computed(() => mode.value === "dark");

  function setMode(next) {
    if (!modes.includes(next)) return;
    mode.value = next;
    document.documentElement.dataset.theme = mode.value;
    document.documentElement.style.colorScheme = isDark.value ? "dark" : "light";
    try {
      localStorage.setItem("flap_theme", mode.value);
    } catch {
      // Switching still works when browser storage is unavailable.
    }
  }

  return { mode, isDark, setMode };
});
